import {
  AnalyticsEvent,
  ButtonComponentV2,
  ChallengeAction,
  Money,
  ProcessTypeInput,
  Typenames,
  VxlButtonStyle,
} from '@varo/graphql-schema-types';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';

export async function loadExpoTabapay() {
  const { default: ExpoTabapay } = await import('@varo/expo-tabapay');
  return ExpoTabapay;
}
export const isTabapayCustomError = (
  card: unknown,
): card is {
  __typename: Typenames.TabaPayCustomError;
  tabaPayErrorTitle: string;
  tabaPayErrorMessage: string;
  actions: ChallengeAction[];
  displayAnalytics?: AnalyticsEvent;
  code: string;
  statusCode?: string;
} =>
  typeof card === 'object' &&
  card !== null &&
  'tabaPayErrorTitle' in card &&
  'actions' in card;
export const getTabapayErrorScreen = (
  result: unknown,
):
  | {
      screenType: ErrorScreenType.Error;
      messageHeadline: string;
      messageBody: string;
      primaryButton?: ButtonComponentV2;
      secondaryButton?: ButtonComponentV2;
      analytics?: AnalyticsEvent;
      code: string;
      statusCode?: string;
    }
  | undefined => {
  if (!isTabapayCustomError(result)) {
    return undefined;
  }
  const customError = result;

  const primaryButton = customError.actions.find(
    (action) => action.button.buttonStyle === VxlButtonStyle.Primary,
  )?.button;

  const secondaryButton = customError.actions.find(
    (action) => action.button.buttonStyle === VxlButtonStyle.Secondary,
  )?.button;

  return {
    screenType: ErrorScreenType.Error,
    messageHeadline: customError.tabaPayErrorTitle,
    messageBody: customError.tabaPayErrorMessage,
    primaryButton,
    secondaryButton,
    analytics: customError.displayAnalytics,
    code: customError.__typename,
    statusCode: customError.statusCode,
  };
};
export const isTabapayPartialAuthError = (
  card: unknown,
): card is {
  __typename: Typenames.TabaPayPartialAuth;
  partialAuthTitle: string;
  partialAuthMessage: string;
  actions: ButtonComponentV2[];
  displayAnalytics?: AnalyticsEvent;
  approvedAmount: Money;
  statusCode: string;
} =>
  typeof card === 'object' &&
  card !== null &&
  'partialAuthTitle' in card &&
  'partialAuthMessage' in card &&
  'actions' in card;
export const getTabapayPartialAuthErrorScreen = (
  result: unknown,
  t: (key: string, options?: { amount?: string }) => string,
):
  | {
      screenType: ErrorScreenType.Error;
      messageHeadline: string;
      messageBody: string;
      primaryButton?: ButtonComponentV2;
      analytics?: AnalyticsEvent;
      isPartialAuth: boolean;
      processType: string;
      approvedAmount: string;
      statusCode?: string;
    }
  | undefined => {
  if (!isTabapayPartialAuthError(result)) {
    return;
  }
  const partialAuthError = result;
  const primaryButton = partialAuthError.actions.find(
    (action) => action.buttonStyle === VxlButtonStyle.Primary,
  );

  const formattedAmount = partialAuthError.approvedAmount.formatted;

  const partialAuthTitle = t('externalAccounts.tabapayPartialAuth.title', {
    amount: formattedAmount,
  });
  const partialAuthMessage = t('externalAccounts.tabapayPartialAuth.body', {
    amount: formattedAmount,
  });

  return {
    screenType: ErrorScreenType.Error,
    messageHeadline: partialAuthTitle,
    messageBody: partialAuthMessage,
    analytics: partialAuthError.displayAnalytics,
    primaryButton: primaryButton,
    isPartialAuth: true,
    processType: ProcessTypeInput.Transaction,
    approvedAmount: partialAuthError.approvedAmount.amount.toString(),
    statusCode: partialAuthError.statusCode,
  };
};
